import { Stack } from "@mui/material";
import { FC } from "react";
import { ECompanyContractStatus } from "@/types/enum";
import { TopList } from "@/features/company/components/TopList";
import { CompanyListTable } from "@/features/company/components/CompanyListTable";

type TCompanyTrialListProps = {};

const contractStatuses = [ECompanyContractStatus.TRIAL];

export const CompanyTrialList: FC<TCompanyTrialListProps> = () => {
  return (
    <Stack gap={2}>
      <TopList contractStatuses={contractStatuses} />
      <CompanyListTable contractStatuses={contractStatuses} />
    </Stack>
  );
};
